module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "abbrs"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rabbrs"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AB")]), _vm._v(" Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AEL")]), _vm._v(" "), _c('i', [_vm._v("Ancient Egyptian Literature,")]), _vm._v(" M. Lichtheim. 3 vols. Berkley, CA: University of California Press, 1971-80")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AJSL")]), _vm._v(" "), _c('i', [_vm._v("American Journal of Semitic Languages and Literatures")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Aq")]), _vm._v(" Aquila’s Greek translation of Proverbs")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AUSS")]), _vm._v(" "), _c('i', [_vm._v("Andrews University Seminary Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BETL")]), _vm._v(" Bibliotheca Ephemeridum Theologicarum Lovaniensium")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Bib")]), _vm._v(" "), _c('i', [_vm._v("Biblica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BKAT")]), _vm._v(" Biblischer Kommentar: Altes Testamentum")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BNTC")]), _vm._v(" Black’s New Testament Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BTS")]), _vm._v(" "), _c('i', [_vm._v("Bible et terre sainte")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BWL")]), _vm._v(" "), _c('i', [_vm._v("Babylonian Wisdom Literature,")]), _vm._v(" W. G. Lambert. Winona Lake, IN: Eisenbrauns, 1996")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BZAW")]), _vm._v(" Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("CAD")]), _vm._v(" "), _c('i', [_vm._v("The Assyrian Dictionary of the Oriental Institute of the University of Chicago.")]), _vm._v(" Chicago, 1956-2006")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("CBQ")]), _vm._v(" "), _c('i', [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("COS")]), _vm._v(" "), _c('i', [_vm._v("The Context of Scripture.")]), _vm._v(" Edited by W. W. Hallo. Leiden: Brill, 1997-2002")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ESV")]), _vm._v(" English Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ETL")]), _vm._v(" "), _c('i', [_vm._v("Ephemerides Theologicae Lovanienses")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("EVV")]), _vm._v(" English versions")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("GKC")]), _vm._v(" "), _c('i', [_vm._v("Gesenius’ Hebrew Grammar.")]), _vm._v(" Edited by E. Kautzsch. Translated by A. E. Cowley. 2nd ed. Oxford: OUP, 1910")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("GNB")]), _vm._v(" Good News Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HS")]), _vm._v(" "), _c('i', [_vm._v("Hebrew Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Int")]), _vm._v(" "), _c('i', [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiii"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JANESCU")]), _vm._v(" "), _c('i', [_vm._v("Journal of the Ancient Near Eastern Society of Columbia University")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JBL")]), _vm._v(" "), _c('i', [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JETS")]), _vm._v(" "), _c('i', [_vm._v("Journal of the Evangelical Theological Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JNSL")]), _vm._v(" "), _c('i', [_vm._v("Journal of Northwest Semitic Languages")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Joüon")]), _vm._v(" Joüon, P. A. "), _c('i', [_vm._v("A Grammar of Biblical Hebrew.")]), _vm._v(" Translated and revised by T. Muraoka. 2 vols. Subsidia biblical 14/1-2. Rome: Editrice Pontificio Istituto Biblico, 1993 (corrected edition)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JQR")]), _vm._v(" "), _c('i', [_vm._v("Jewish Quarterly Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JSOT")]), _vm._v(" "), _c('i', [_vm._v("Journal for the Study of the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JSOTSup")]), _vm._v(" Journal for the Old Testament: Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JTS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("K")]), _vm._v(" Kethibh (the written Hebrew text of the MT)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("KJV")]), _vm._v(" King James Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LXX")]), _vm._v(" Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ms(s)")]), _vm._v(" manuscript(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MT")]), _vm._v(" Massoretic Text")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NAB")]), _vm._v(" New American Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NCB")]), _vm._v(" New Century Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NICOT")]), _vm._v(" New International Commentary on the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NIDNTT")]), _vm._v(" "), _c('i', [_vm._v("New International Dictionary of New Testament Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NIDOTTE")]), _vm._v(" "), _c('i', [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIGTC")]), _vm._v(" New International Greek Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIV")]), _vm._v(" New International Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIVAC")]), _vm._v(" New International Version Application Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NJPSV")]), _vm._v(" New Jewish Publication Society Version (2nd ed.)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NRSV")]), _vm._v(" New Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NT")]), _vm._v(" New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OT")]), _vm._v(" Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OTL")]), _vm._v(" Old Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("OTP")]), _vm._v(" "), _c('i', [_vm._v("The Old Testament Pseudepigrapha.")]), _vm._v(" J. H. Charlesworth (ed.). 2 vols. Garden City, NY: Doubleday, 1983-85")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Q")]), _vm._v(" Qere (the Hebrew text to be read out from the MT)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RB")]), _vm._v(" "), _c('i', [_vm._v("Revue biblique")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("REB")]), _vm._v(" Revised English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SBFLA")]), _vm._v(" "), _c('i', [_vm._v("Studii Biblici Fransiscani Liber Annus")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLDS")]), _vm._v(" Society of Biblical Literature Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Sym")]), _vm._v(" Symmachus’ Greek translation of Proverbs")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Syr")]), _vm._v(" Syriac")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiv"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("Targ")]), _vm._v(" Targum")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Theod")]), _vm._v(" Theodotion’s Greek translation of Proverbs")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TOTC")]), _vm._v(" Tyndale Old Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TynB")]), _vm._v(" "), _c('i', [_vm._v("Tyndale Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("VT")]), _vm._v(" "), _c('i', [_vm._v("Vetus Testamentum")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("VTSup")]), _vm._v(" Supplements to Vetus Testamentum")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Vulg")]), _vm._v(" Vulgate")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WMANT")]), _vm._v(" Wissenschaftliche Monographien zum Alten un Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("WO")]), _vm._v(" "), _c('i', [_vm._v("Die Welt des Orient")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZAH")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift für Althebräistik")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZAW")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZTK")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e29dc0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-lucas-0008.vue
// module id = 75
// module chunks = 0